import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Meeting, MeetingCreate, MeetingFilter } from '../data/meeting';

export function createMeetingService(client: AxiosInstance) {
  return createCrudService<Meeting, MeetingCreate, MeetingFilter>(
    client,
    '/crm/Meeting',
    'id',
  );
}

export type MeetingService = CrudService<Meeting, MeetingCreate, MeetingFilter>;
